export const createStatusChartOption = (accounts) => ({
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "shadow",
    },
    textStyle: {
      fontFamily: 'Montserrat, sans-serif'
    }
  },
  grid: {
    left: "0%",
    right: "0%",
    top: "0%",
    bottom: "0%",
    containLabel: false,
  },
  xAxis: {
    type: "value",
    show: false,
    axisLabel: {
      fontFamily: 'Montserrat, sans-serif'
    }
  },
  yAxis: {
    type: "category",
    data: accounts.map((account) => account.name),
    show: false,
    axisLabel: {
      fontFamily: 'Montserrat, sans-serif'
    }
  },
  series: [
    {
      type: "bar",
      data: accounts.map((account) => account.value),
      itemStyle: {
        color: "#4F46E5",
      },
    },
  ],
});

export const createRevenuePerMonthOption = (revenuePerMonth, accountColors, formatCurrency) => {
  if (!revenuePerMonth || !revenuePerMonth.series || !revenuePerMonth.months) {
    return {};
  }

  return {
    tooltip: {
      trigger: "axis",
      formatter: (tooltipParams) => {
        let result = `${tooltipParams[0].axisValue}<br/>`;
        tooltipParams.forEach((chartParam) => {
          const color = chartParam.color ? chartParam.color : "#666";
          const marker =
            `<span style="display:inline-block;margin-right:4px;border-radius:50%;` +
            `width:10px;height:10px;background-color:${color}"></span>`;
          result += `${marker}${chartParam.seriesName}: ${formatCurrency(chartParam.value)}<br/>`;
        });
        return result;
      },
      textStyle: {
        fontFamily: 'Montserrat, sans-serif'
      }
    },
    legend: {
      show: false,
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      top: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: revenuePerMonth.months,
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        fontFamily: 'Montserrat, sans-serif'
      }
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (value) => {
          if (value >= 1000) {
            return `$${(value / 1000).toFixed(0)}K`;
          }
          return `$${value}`;
        },
        fontFamily: 'Montserrat, sans-serif'
      },
      splitLine: {
        lineStyle: {
          color: "rgba(0, 0, 0, 0.05)",
        },
      },
    },
    series: revenuePerMonth.series.map((series, index) => ({
      name: series.name,
      type: "line",
      smooth: true,
      areaStyle: {
        opacity: 0.1,
      },
      data: series.data,
      itemStyle: {
        color: accountColors[index % accountColors.length],
      },
      lineStyle: {
        color: accountColors[index % accountColors.length],
        width: 2,
      },
    })),
  };
};
